import { SaveButton } from "components/Buttons"
import ModalComponent from "components/Modals"
import React, { useEffect } from "react"
import { connect } from "react-redux"
import { Card, CardBody, Col, Row } from "reactstrap"
import {
  hideInactiveEventWarningModal,
  resetEventInviteList,
  getMetaTags,
} from "store/actions"
import { copyButtonHandler } from "utils"
import Add_users_by_access_code from "./add_users_by_access_code"
import Add_users_by_tags from "./add_users_by_tags"
import Add_users_manually from "./add_users_manually"
import Experience_access from "./experience_access"

const PermissionsTab = ({
  hideInactiveEventWarningModal,
  isInactiveEventWarningModalOpen,
  selectedEvent,
  resetEventInviteList,
  getMetaTags,
}) => {
  useEffect(() => {
    getMetaTags()
    return () => {
      resetEventInviteList()
    }
  }, [])

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <h3>User Access</h3>
          <Row className="mt-3">
            <Col>
              <h5>Public Web URL for RSVP:</h5>
            </Col>
          </Row>
          <Row className="my-1">
            <Col>
              <span>
                {selectedEvent?.rsvp_webpage_new_url}
                {"  "}
                <SaveButton
                  type="button"
                  onClick={() => {
                    copyButtonHandler(selectedEvent?.rsvp_webpage_new_url)
                  }}
                  content="Copy"
                  color="light"
                  size="sm"
                />
              </span>
            </Col>
          </Row>
          <Experience_access />
          <Add_users_by_tags />
          <Add_users_manually />
          <Add_users_by_access_code />
        </CardBody>
      </Card>
      <ModalComponent
        title="Send Invites"
        open={isInactiveEventWarningModalOpen}
        onClose={() => hideInactiveEventWarningModal(false)}
      >
        <Row>
          <h5>
            You are attempting to invite attendees to an event that has a status
            of Inactive. You need to build the menu first in order publish the
            event and send the email invite(s).
          </h5>
        </Row>
        <Row className="mt-3">
          <Col>
            <SaveButton
              type="button"
              fullWidth={true}
              color="danger"
              content="Cancel"
              onClick={() => hideInactiveEventWarningModal(false)}
            />
          </Col>
        </Row>
      </ModalComponent>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  isInactiveEventWarningModalOpen:
    state.experiences.isInactiveEventWarningModalOpen,
  selectedEvent: state.experiences.selectedEvent,
})

const mapDispatchToProps = dispatch => ({
  hideInactiveEventWarningModal: () =>
    dispatch(hideInactiveEventWarningModal()),
  resetEventInviteList: () => dispatch(resetEventInviteList()),
  getMetaTags: () => dispatch(getMetaTags()),
})

export default connect(mapStateToProps, mapDispatchToProps)(PermissionsTab)
